(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sidebar"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalizeCategory = (type) => {
    if (/^(t-?shirts?|tees?)$/.test(type) || /(^|-)(t-?shirt|tee)(-|$)/.test(type)) return 't_shirts';
    if (/hood/.test(type)) return 'hoodies';
    if (/sweatshirt|sweater|crewneck/.test(type)) return 'sweatshirts';
    if (/headwear|(^|-)(cap|caps|hat|hats|beanie|beanies)(-|$)/.test(type)) return 'headwear';
    if (/bag|backpack|tote/.test(type)) return 'bags';
    return type;
  };
  function init(root) {
    root.querySelectorAll('.collection-browser').forEach((browser) => {
      if (browser.dataset.initialized) return;
      browser.dataset.initialized = 'true';
      const grid = browser.querySelector('[data-collection-products]');
      const panel = browser.querySelector('.collection-sidebar');
      const media = window.matchMedia('(max-width: 700px)');
      if (panel) {
        const resize = () => { panel.open = !media.matches; };
        resize(); media.addEventListener('change', resize);
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(browser)) media.removeEventListener('change', resize);
        }, { once: true });
      }
      const initialUrl = new URL(window.location.href);
      const state = { era: 'all', category: 'all', price: 'any', sort: 'featured', page: 1 };
      let cards = [], ready = false;
      const controls = [...browser.querySelectorAll('[data-filter-controls], [data-era-filter], [data-sort], [data-clear]')];
      const readState = () => {
        const params = new URL(window.location.href).searchParams;
        state.era = browser.querySelector('[data-era-filter]') && ['sfii', 'sf6'].includes(params.get('era')) ? params.get('era') : 'all';
        state.category = ['t_shirts', 'hoodies', 'sweatshirts', 'headwear', 'bags'].includes(params.get('category')) ? params.get('category') : 'all';
        state.price = ['under30', '30to49', '50plus'].includes(params.get('price')) ? params.get('price') : 'any';
        state.sort = ['price-ascending', 'price-descending'].includes(params.get('sort')) ? params.get('sort') : 'featured';
        state.page = Math.max(1, Number.parseInt(params.get('results_page'), 10) || 1);
      };
      const saveState = () => {
        const url = new URL(window.location.href);
        ['era', 'category', 'price', 'sort'].forEach((key) => {
          if (['all', 'any', 'featured'].includes(state[key])) url.searchParams.delete(key);
          else url.searchParams.set(key, state[key]);
        });
        url.searchParams.delete('page'); url.searchParams.delete('sort_by');
        [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
        if (state.page > 1) url.searchParams.set('results_page', state.page);
        else url.searchParams.delete('results_page');
        window.history.pushState(null, '', url);
      };
      const render = () => {
        if (!ready) return;
        const inEra = cards.filter(card => state.era === 'all' || card.dataset.era === state.era);
        browser.querySelectorAll('[data-category-choice]').forEach(input => {
          const count = inEra.filter(card => input.value === 'all' || normalizeCategory(card.dataset.filterCategory) === input.value).length;
          input.checked = input.value === state.category;
          browser.querySelector(`[data-category-count="${input.value}"]`).textContent = count;
          input.disabled = count === 0 && !input.checked;
        });
        browser.querySelectorAll('[data-price-choice]').forEach(input => { input.checked = input.value === state.price; });
        browser.querySelectorAll('[data-era-filter]').forEach(button => {
          const active = button.dataset.eraFilter === state.era;
          button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
        });
        browser.querySelector('[data-sort]').value = state.sort;
        const matches = inEra.filter(card => {
          const price = Number(card.dataset.price);
          return (state.category === 'all' || normalizeCategory(card.dataset.filterCategory) === state.category)
            && (state.price === 'any' || (state.price === 'under30' && price < 3000) || (state.price === '30to49' && price >= 3000 && price < 5000) || (state.price === '50plus' && price >= 5000));
        });
        if (state.sort !== 'featured') matches.sort((a, b) => state.sort === 'price-ascending' ? Number(a.dataset.price) - Number(b.dataset.price) : Number(b.dataset.price) - Number(a.dataset.price));
        const pages = Math.max(1, Math.ceil(matches.length / 24));
        state.page = Math.min(state.page, pages);
        // Keep only the current page mounted; all collection cards remain in memory.
        grid.replaceChildren(...matches.slice((state.page - 1) * 24, state.page * 24));
        browser.querySelector('[data-empty]').hidden = matches.length !== 0;
        browser.querySelector('[data-pagination]').hidden = pages < 2;
        browser.querySelector('[data-previous]').disabled = state.page === 1;
        browser.querySelector('[data-next]').disabled = state.page === pages;
        browser.querySelector('[data-page-label]').textContent = browser.dataset.pageLabel.replace('[current]', state.page).replace('[total]', pages);
      };
      const update = () => { state.page = 1; render(); saveState(); };
      browser.querySelectorAll('[data-category-choice]').forEach(input => input.addEventListener('change', () => { state.category = input.value; update(); }));
      browser.querySelectorAll('[data-price-choice]').forEach(input => input.addEventListener('change', () => { state.price = input.value; update(); }));
      browser.querySelectorAll('[data-era-filter]').forEach(button => button.addEventListener('click', () => { state.era = button.dataset.eraFilter; update(); }));
      browser.querySelector('[data-sort]').addEventListener('change', event => { state.sort = event.target.value; update(); });
      browser.querySelector('[data-clear]')?.addEventListener('click', () => { state.era = 'all'; state.category = 'all'; state.price = 'any'; update(); });
      ['previous', 'next'].forEach(direction => browser.querySelector(`[data-${direction}]`).addEventListener('click', () => {
        state.page += direction === 'next' ? 1 : -1; render(); saveState();
        browser.querySelector('.collection-browser__toolbar').scrollIntoView({ block: 'start' });
      }));
      const onPopState = () => { if (browser.isConnected) { readState(); render(); } };
      window.addEventListener('popstate', onPopState);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(browser)) window.removeEventListener('popstate', onPopState); }, { once: true });
      async function load() {
        browser.querySelector('[data-loading]').hidden = false;
        browser.querySelector('[data-load-error]').hidden = true;
        const loaded = [];
        const seen = new Set();
        const append = source => source.querySelectorAll('[data-collection-products] > .product-grid-item').forEach(card => {
          // Older/cached card markup may lack an ID. Never deduplicate all missing IDs together.
          const key = card.dataset.productId || card.querySelector('a[href]')?.getAttribute('href');
          if (key && seen.has(key)) return;
          if (key) seen.add(key);
          loaded.push(card);
        });
        try {
          // Existing Shopify filter/page URLs must not restrict the source catalogue.
          const needsCleanSource = initialUrl.searchParams.has('page') || initialUrl.searchParams.has('sort_by') || [...initialUrl.searchParams.keys()].some(key => key.startsWith('filter.'));
          let next;
          if (needsCleanSource) next = browser.dataset.collectionUrl;
          else { append(browser); next = browser.querySelector('[data-next-page]')?.getAttribute('href'); }
          const visited = new Set();
          while (next) {
            const url = new URL(next, window.location.origin);
            if (url.origin !== window.location.origin) throw new Error('Unexpected collection origin');
            url.searchParams.set('section_id', browser.dataset.sectionId);
            if (initialUrl.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', initialUrl.searchParams.get('preview_theme_id'));
            if (visited.has(url.href)) throw new Error('Repeated collection page');
            visited.add(url.href);
            const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
            if (!response.ok) throw new Error('Collection request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const source = doc.getElementById(browser.id);
            if (!source?.querySelector('[data-collection-products]')) throw new Error('Collection response missing');
            append(source); next = source.querySelector('[data-next-page]')?.getAttribute('href');
          }
          if (!browser.isConnected) return;
          cards = loaded; ready = true;
          controls.forEach(control => { control.disabled = false; });
          browser.querySelector('[data-server-pagination]').hidden = true;
          readState(); render();
        } catch (error) {
          browser.querySelector('[data-load-error]').hidden = false;
        } finally { browser.querySelector('[data-loading]').hidden = true; }
      }
      browser.querySelector('[data-retry]').addEventListener('click', load);
      load();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
